import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ICustomerTheme } from './@core/interfaces/customer-theme.interface';
import { CustomerConfigService } from './@core/services/customer-config.service';
import { GlobalLoadingService } from './@core/services/global-loading.service';
import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss',
  imports: [CommonModule, RouterModule, ToastModule, ConfirmDialog, LoadingSpinnerComponent],
})
export class AppComponent implements OnInit {
  title: string = 'TV App';

  customerTheme: ICustomerTheme;
  isLoading: boolean = false;

  constructor(
    private readonly spinnerService: GlobalLoadingService,
    private readonly customerConfigsService: CustomerConfigService,
  ) {
    this.spinnerService.loading$.subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.customerConfigsService.checkInitErrors();
    });
  }
}
